import React, { useState } from 'react';
import MusicForm from './MusicForm';

function AddMusic() {
  const [form, setForm] = useState({ music_name: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const token = localStorage.getItem('authToken');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!form.music_name.trim()) return;
    setIsSubmitting(true);
    console.log('Token:', token);
    const res = await fetch('https://epicnyte.sablis.com/api/music', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Music added!');
      setForm({ music_name: '' });
    } else {
      const data = await res.json();
      alert(data.message || 'Error adding music');
    }

    setIsSubmitting(false);
  };

  return <MusicForm form={form} onChange={handleChange} onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
}

export default AddMusic;
